import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';

@Component({
  selector: 'ptl-editable-section-title',
  templateUrl: './editable-section-title.component.html',
  styleUrls: ['./editable-section-title.component.scss'],
})
export class EditableSectionTitleComponent implements OnChanges {
  @Input() title = '';
  @Output() titleSaved = new EventEmitter<string>();

  sectionTitle = '';

  ngOnChanges() {
    if (!this.sectionTitle) {
      this.sectionTitle = this.title || '';
    }
  }

  saveTitle() {
    const trimmed = (this.sectionTitle || '').trim();

    if (trimmed !== (this.title || '').trim()) {
      this.titleSaved.emit(trimmed);
    }
  }
}
